type Props = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  id?: string;
};

const SectionHeading = ({ eyebrow, title, desc, align = 'left', id }: Props) => (
  <div
    id={id}
    className={`flex flex-col gap-2 ${align === 'center' ? 'items-center text-center' : 'items-start'}`}
  >
    <span className="inline-flex items-center gap-2 text-xs font-label font-medium uppercase tracking-[0.18em] text-accent-700">
      <span className="h-px w-6 bg-accent-500" aria-hidden="true" />
      {eyebrow}
    </span>
    <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[32px] md:leading-tight">
      {title}
    </h2>
    {desc && (
      <p className={`max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-[15px] ${align === 'center' ? 'mx-auto' : ''}`}>
        {desc}
      </p>
    )}
  </div>
);

export default SectionHeading;